<!--
 * @Description:服务管理服务项目服务事项
 * @Author:sunhuihong
 * @Date: 2022-05-23 14:43:52
 * @LastEditTime: 2024-05-24 16:39:11
-->
<template>
  <div>
    <el-form  class="form" :model="hserviceMatter" ref="hserviceMatterForm" :rules="rules">
      <el-row style="margin: 30px 25px; padding-top: 20px;" :gutter="0" type="flex" justify="space-between">
        <el-col :span="16" style="position: relative;">
          <div style="margin-bottom: 20px;">
            <span class="title-tag"></span>
            <span class="title-content">注意事项</span>
          </div>
          <el-popover ref="popover" placement="bottom" trigger="click" >
            <el-cascader-panel 
             ref="cascader"
             :options="dataList"
             :props="defaultProps"
             @change="handleChangeContent"
             v-model="selectedOptions">
            </el-cascader-panel>
            <el-button type="text" slot="reference" @click="handleImportServiceContent" :disabled="readonly" 
              style="position: absolute; right: 5px; top: 0; color: #3A7FF3;" >
              选择模板
            </el-button>          
          </el-popover>         
          <el-form-item prop="content">
            <el-input v-model="hserviceMatter.content"  @keyup.native="handleInputServiceCotent" 
              minlength="1" maxlength="499" type="textarea" ref="hserviceMatterContent" :rows="4" 
              :disabled="readonly" :readonly="readonly" placeholder="请输入">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" >
          <div style="height: 1100px; overflow-y: scroll;">
            <img style="width: 100%;" src="@/assets/hsvccfg/app.png"  alt="">
          </div>
        </el-col>
      </el-row>
    </el-form>   
    <div class="bk-wizard-bottons" style="padding-right: 25px;">
      <wizard-buttons :mode="mode" :status="btnStatus" @btnpressed="handleBtnSelection" />
    </div>
  </div>
</template>

<script>
import hserviseStore from './HserviceDetailStore.js';
import Constant from '@/global/Constant.js'

let HserviceServiceItemsPanel= {
  name: 'HserviceServiceItemsPanel',
  hserviseStore,
  
  data() {
    let validateContent = (_rule, _value, callback) => {
			if (this.hserviceMatter.content && this.hserviceMatter.content.trim().length == 0) {
				callback(new Error('注意事项不能输入全空格或全换行'));
			} else if (this.hserviceMatter.content == ''){
				callback(new Error('请输入注意事项'));
			} else {
        callback();
      }
    };

    return {
      btnStatus: {'prev': true, 'next': true, 'submit': false}, 
      selectedOptions: [],//选中的节点值，用于回显
      code: '',
      dataList: null,
      defaultProps: {
        value: 'id',
        children: 'matterDTOList',
        label: 'name',
      } ,
      rules: {
        content: [
          { required: true, validator: validateContent, trigger: ['blur', 'change']},
        ]
      } 
    }
  },

  computed: {
    mode() {
      return hserviseStore.state.mode;
    },
  
    hserviceMatter() {
      return hserviseStore.state.matterCfgBaseInfoDO;
    },
    
    type() {
      return hserviseStore.state.matterCfgBaseInfoDO.type;   
    },

    readonly() {
      return hserviseStore.state.mode == 'details';
    }  
  },

  methods: {
    //输入框输入服务事项
    handleInputServiceCotent(target) {
      if (target) {
        hserviseStore.state.matterCfgBaseInfoDO.content = this.$refs.hserviceMatterContent.value;
      } else {
        hserviseStore.state.matterCfgBaseInfoDO.content = '';
      }
    },

    //系统导入服务事项
    handleImportServiceContent() {  
      let params = {institutionId: hserviseStore.state.serviceCfg.institutionId};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_TREE_MATTER,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then((result) => {
        if (result != null) {
          this.dataList = this.getTreeData(result.data);
        }
      });
    },

    handleChangeContent (value) {
      if (value.length > 0) {
        let checkNode = this.$refs['cascader'].getCheckedNodes()[0];
        hserviseStore.state.matterCfgBaseInfoDO.content = checkNode.data.content;
        hserviseStore.state.matterCfgBaseInfoDO.hserviceId = checkNode.data.id;
		    hserviseStore.state.matterCfgBaseInfoDO.type = 1;
      }
      this.$refs["popover"].doClose();
      this.$forceUpdate();
    },

     //判断列表，把最后的children设为undefined
     //(children若为空数组，则将children设为undefined ,children若不为空数组，则继续 递归调用 本方法)
    getTreeData(data) {
      for(let item of data) {
        if (item.matterDTOList == null || item.matterDTOList.length == 0) {
          item.matterDTOList = undefined;
        } else {
          this.getTreeData(item.matterDTOList);
        }
      }
      return data;
    },

    handleBtnSelection(operate) {
      if (this.mode == 'details' || operate != 'next') {
        this.$emit("panel-operate", operate);
        return true;
      }      
      this.$refs.hserviceMatterForm.validate((valid) => {
        if (!valid) {
          return false
        } else {
          this.$emit("panel-operate", operate);
          return true;
        }
      });
    },
  }, 

  destroyed() {
    //销毁的时候同步数据
    hserviseStore.commit('changeMatterCfgBaseInfoDO', this.hserviceMatter);
  },
}
export default HserviceServiceItemsPanel
</script>

<style scoped>
.title-tag {
  display: inline-block;
  width: 4px;
  height: 16px;
  background: #2A97FF;
  border-radius: 2px;
  margin-right: 9px;
  vertical-align: middle;
} 

.title-content {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  vertical-align: middle;
}

.form {
  margin-bottom: 60px;
}

</style>





// WEBPACK FOOTER //
// src/components/hsvcmng/components/hservicedetails/ServiceItemsPanel.vue